/** Pumpkin body on an 84 × 76 canvas, shared by the pumpkin loader and the pumpkin pop. */
export const PUMPKIN_VIEW_WIDTH = 84;
export const PUMPKIN_VIEW_HEIGHT = 76;
export const PUMPKIN_BODY_PATH = "M42 18 C36 14 26 14 18 18 C4 25 2 52 14 64 C22 72 34 73 42 69 C50 73 62 72 70 64 C82 52 80 25 66 18 C58 14 48 14 42 18 Z";
export const PUMPKIN_STEM_PATH = "M42 14 C38 6 46 2 50 4";

/** A bat on a 34 × 16 canvas. */
export const BAT_VIEW_WIDTH = 34;
export const BAT_VIEW_HEIGHT = 16;
export const BAT_PATH =
	"M17 4 C15.5 4 14.6 5.2 14.4 6.4 C12 3 8 1.4 3 2.2 C5 3.6 5.6 5.8 5 8 C3.4 7.4 1.6 7.6 0 8.6 C4 9.4 7.6 11.6 9.6 14.6 C10.6 12.6 12.4 11.4 14.6 11.6 C15 13 15.9 14 17 14 C18.1 14 19 13 19.4 11.6 C21.6 11.4 23.4 12.6 24.4 14.6 C26.4 11.6 30 9.4 34 8.6 C32.4 7.6 30.6 7.4 29 8 C28.4 5.8 29 3.6 31 2.2 C26 1.4 22 3 19.6 6.4 C19.4 5.2 18.5 4 17 4 Z";
